"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Styling_1 = require("../../Styling");

var inheritFont = {
  fontFamily: 'inherit'
};
var GlobalClassNames = {
  root: 'ms-Fabric'
};

exports.getStyles = function (props) {
  var theme = props.theme,
      className = props.className,
      isFocusVisible = props.isFocusVisible;
  var classNames = Styling_1.getGlobalClassNames(GlobalClassNames, theme);
  return {
    root: [classNames.root, isFocusVisible && 'is-focusVisible ms-Fabric--isFocusVisible', theme.fonts.medium, {
      color: theme.palette.neutralPrimary,
      selectors: {
        '& button': inheritFont,
        '& input': inheritFont,
        '& textarea': inheritFont
      }
    }, className]
  };
};